"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MoneyFilled = function MoneyFilled(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm1.266 14.453a3.21 3.21 0 01-.766.2V18a.5.5 0 01-1 0v-1.347A3.9 3.9 0 019.248 15.6a.5.5 0 01.7-.711 2.85 2.85 0 002.93.644 1.638 1.638 0 001.022-1.657c0-.937-.72-1.323-1.909-1.849C10.916 11.552 9.7 11.014 9.7 9.6a2.3 2.3 0 011.46-2.1 2.583 2.583 0 01.343-.111V6a.5.5 0 011 0v1.335a2.928 2.928 0 011.651.84.5.5 0 11-.7.711 1.719 1.719 0 00-1.905-.465A1.306 1.306 0 0010.7 9.6c0 .726.646 1.048 1.7 1.514 1.116.493 2.5 1.108 2.5 2.763a2.646 2.646 0 01-1.634 2.576z",
    fill: "currentColor"
  })));
};

var _default = MoneyFilled;
exports["default"] = _default;